module.exports = __webpack_public_path__ + "static/media/12-8.5cc75ab9.mp3";